import { mapState } from "vuex";

import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

import StaffUsersList from "../facility/StaffUsersList.vue";
import FacilitySettings from "../facility/facility-settings/FacilitySettings.vue";
import emailTemplates from "../emailTemplates/email-list/EmailList.vue";
import residentDepartTransfer from "../departureAndTransfer/departureAndTransfer.vue";
import MailingLists from "../mailing/mailingList/MailingLists.vue";
import LocationManagement from "@/views/settings/locationManagement/locationsManagement/LocationManagement.vue";
import CareLevels from "@/views/settings/careLevels/CareLevels.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VendorList from "../vendorList/VendorList.vue";
import NewsletterSettings from "../newsletter/NewsletterSettings.vue";
import LifestyleProgramsSettings from "../lifestylePrograms/LifestyleProgramsSettings.vue";
import UserProfile from "../userProfile/UserProfile.vue";
import ResidentSettings from "../residentSettings/ResidentSettings.vue";
import AdHocActivitiesManager from "../adHocActivitiesManager/AdHocActivitiesManager.vue";
import MaintenanceManagement from "@/views/settings/maintenanceManagement/MaintenanceManagement.vue";
import MaintenanceCategories from "@/views/settings/maintenanceManagement/maintenanceCategories/MaintenanceCategories.vue";
import WingsManagement from "@/views/settings/locationManagement/wingsManagement/WingsManagement.vue";
import Care from "@/views/settings/care/Care.vue";
import {StaffAccessLevels} from "@/enums/StaffAccessLevels";

export default {
  name: "settings",
  data() {
    return {
      dialog: false,
      popupRestrictedResidents: false,
      resetPasswordDisabled: false,
      currentDate: new Date().getDate(),
      guestbookRules: null,
      timeFormat: '',
      pickers1: {
        start: false,
        end: false
      },
      pickers: {
        start: false,
        end: false
      },
      loading: false,
      time1: {
        start: null,
        end: null,
      },
      time: {
        start: null,
        end: null,
      },
      startTimeValid: true,
      endTimeValid: true,
      emptySurveysItem: [{ id: null, name: this.$t('GeneralTranslations.NotSelected') }]
    };
  },
  components: {
    "email-templates": emailTemplates,
    "resident-depart-transfer": residentDepartTransfer,
    "facility-settings": FacilitySettings,
    "mailing-lists": MailingLists,
    "vendor-list": VendorList,
    "newsletter-settings": NewsletterSettings,
    "user-profile": UserProfile,
    "location-management": LocationManagement,
    "wings-management": WingsManagement,
    "care-levels": CareLevels,
    "lifestyle-programs-settings": LifestyleProgramsSettings,
    "resident-settings": ResidentSettings,
    "ad-hoc-activities-manager": AdHocActivitiesManager,
    "maintenance-management": MaintenanceManagement,
    "maintenance-categories": MaintenanceCategories,
    "care-list": Care,
    StaffUsersList: StaffUsersList,
    VueCtkDateTimePicker,
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    StaffAccessLevels() {
      return StaffAccessLevels
    },
    ...mapState({
      user() {
        return this.$store.state.authModule.user;
      },
      facility() {
        return this.$store.state.facilityModule.selectedFacility;
      },
      currentFacility() {
        return this.$store.state.authModule.currentFacility;
      },
      residents() {
        return this.$store.state.residentModule.residentsShortData; //todo filter out ones already on there.
      },
      triggeredSurveys() {
        return [...this.$store.state.surveyModule.surveys, ...this.emptySurveysItem]
      }
    }),
    formattedVisitsStartTime() {
      if (!this.facility.timeFormat) return ''

      return moment(this.guestbookRules.start, 'HH:mm').format(this.facility.timeFormat)
    },
    formattedVisitsEndTime() {
      if (!this.facility.timeFormat) return ''

      return moment(this.guestbookRules.end, 'HH:mm').format(this.facility.timeFormat)
    },
    lunchStartFormatted() {
      if (!this.facility.timeFormat) return ''

      return moment(this.guestbookRules.lunchStart, 'HH:mm').format(this.facility.timeFormat)
    },
    lunchEndFormatted() {
      if (!this.facility.timeFormat) return ''

      return moment(this.guestbookRules.lunchEnd, 'HH:mm').format(this.facility.timeFormat)
    },
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      }
    },
    start() {
      return `${this.guestbookRules.start}:00`;
    },
    end() {
      return `${this.guestbookRules.end}:00`;
    },
    isFacilityHasCareAPI() {
      return this.$store.state.facilityModule.isFacilityHasCareAPI;
    }
  },
  watch: {
    ['guestbookRules.lunchStart'](start) {
      this.guestbookRules.lunchEnd = moment(start, 'h:mma')
        .add(1, 'h')
        .format('HH:mm');
    },
  },
  async created() {
    await this.$store.dispatch('getFacility');
    await this.$store.dispatch("getUser");
    await this.$store.dispatch("getOrgUsers", this.user.orgId);
    await this.$store.dispatch("getCareAPIKey", this.facility.id);
    this.$store.dispatch("getGuestbookRules");
    this.$store.dispatch("getTriggeredSurveys");
    this.$store.dispatch("getUsersRoles");
  },
  mounted() {
    this.timeFormat = this.facility.timeFormat.includes('A') ? 'ampm' : '24h'
    this.guestbookRules = this.$store.state.guestbookModule.guestbookRules;
    this.guestbookRules.start = this.getTime(this.guestbookRules.start);
    this.guestbookRules.end = this.getTime(this.guestbookRules.end);
  },
  methods: {
    async updateNotifications() {
      await firebase
        .firestore()
        .collection("users")
        .doc(this.user.id)
        .update({
          options: this.user.options
        })
        .then(async () => {
          this.$toast.open({
            message: "Notifications settings updated",
            type: "success"
          });
          await this.$store.dispatch("getUser");
        }).catch(() => {
          this.$toast.open({
            message: "Unable to update notifications settings",
            type: "error"
          });
        });
    },
    getTime(time) {
      if (!time) return ''

      if (time.length === 1) {
        return `0${time}:00`;
      } else if (time.length === 2) {
        return `${time}:00`;
      } else if (time.length > 3) {
        return time;
      } else {
        return "00:00"
      }
    },
    validateDateTime() {
      const start = moment();
      const sH = this.guestbookRules.start.split(":")[0]
      const sM = this.guestbookRules.start.split(":")[1]
      start.set({ hour: parseInt(sH), minute: parseInt(sM) })

      const end = moment();
      const sH2 = this.guestbookRules.end.split(":")[0]
      const sM2 = this.guestbookRules.end.split(":")[1]
      end.set({ hour: parseInt(sH2), minute: parseInt(sM2) })

      if (start > end) {
        this.startTimeValid = false;
      } else {
        this.startTimeValid = true;
      }

      if (!this.guestbookRules.end) {
        this.endTimeValid = false;
      } else {
        this.endTimeValid = true;
      }
    },
    isValid() {
      return this.startTimeValid && this.endTimeValid;
    },
    getDateTime(time) {
      const timeSplit = time.split(":").map(a => parseInt(a));
      const dateTime = new Date();

      if (time.includes("pm") && timeSplit[0] !== 12) timeSplit[0] += 12;

      dateTime.setHours(timeSplit[0], timeSplit[1], 0);

      return dateTime;
    },
    async updateGuestBookRules() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      }

      this.loading = true;

      this.guestbookRules.start = String(this.guestbookRules.start);
      this.guestbookRules.end = String(this.guestbookRules.end);

      const formData = { ...this.guestbookRules };

      if (typeof formData.lunchStart === "string") {
        const lunchStartDateTime = this.getDateTime(
          formData.lunchStart.toLowerCase().replace(" ", "")
        );

        formData.lunchStart = firebase.firestore.Timestamp.fromDate(
          lunchStartDateTime
        );
      }

      if (typeof formData.lunchEnd === "string") {
        const lunchEndDateTime = this.getDateTime(
          formData.lunchEnd.toLowerCase().replace(" ", "")
        );

        formData.lunchEnd = firebase.firestore.Timestamp.fromDate(
          lunchEndDateTime
        );
      }

      await this.$store.dispatch("updateGuestbookRules", formData);

      this.loading = false;
    },

    close() {
      this.dialog = false;
      this.resetPasswordEnabled = true;
      this.isReset = false;
    },
    addNewVisitType() {
      this.guestbookRules.visitTypes = this.guestbookRules.visitTypes
        ? this.guestbookRules.visitTypes
        : [];

      this.guestbookRules.visitTypes.push({
        name: "",
        duration: 60,
        maxPartySize: 1,
        description: "",
        maxHoursPerWeekPerResident: 20,
        maxVisitSlotsPerResidentPerWeek: 100,
        restrictedResidents: [],
        isBookable: false
      });
    },
    deleteType(vType) {
      this.guestbookRules.visitTypes = this.guestbookRules.visitTypes.filter(
        visitType => visitType.name != vType.name
      );
    },
    remove(restrictedResidents, item) {
      const index = restrictedResidents.indexOf(item.id);
      if (index >= 0) restrictedResidents.splice(index, 1);
    },
    changeLunchBreak() {
      if (this.guestbookRules.isLunchBreak) {
        this.guestbookRules.lunchStart = moment().hours(14).minute(0).format("HH:mm")
        this.guestbookRules.lunchEnd = moment().hours(15).minute(0).format("HH:mm");
      }
    }
  }
};
